import { Container } from 'components/common';
import cn from 'classnames';
import useIntroBanner from './useIntroBanner';
import BannerImage from './BannerImage';
import BannerText from './BannerText';
import ButtonAction from './ButtonAction';
import BuildNewOrderConfirmationModal from '../BuildNewOrderConfirmationModal';

const IntroBanner = () => {
  const {
    loading,
    image,
    textContent,
    user,
    primaryButton,
    secondaryButton,
    additionalButton,
    handleBuildNewOrder,
    showBuildNewOrderModal,
    setShowBuildNewOrderModal,
  } = useIntroBanner();

  return (
    <>
      {loading ? (
        <div className="tw-min-h-[55rem] md:tw-min-h-[65rem] lg:tw-min-h-[70rem] tw-bg-[#b6b6b5] tw-animate-pulse" />
      ) : (
        <div className="tw-z-[9]">
          <BannerImage image={image}>
            <div
              className={cn(
                'tw-h-[55rem] md:tw-h-[65rem] lg:tw-h-[70rem]',
              )}
            >
              <Container
                className={cn(
                  'tw-h-full tw-flex tw-flex-col tw-justify-end md:tw-justify-center tw-pb-16',
                  user && 'tw-items-center md:tw-items-start',
                )}
              >
                <div className={cn(user ? '' : 'lg:tw-mt-[80px]')}>
                  <BannerText
                    {...textContent}
                    centered={Boolean(user)}
                  />
                </div>
                <div
                  className={cn(
                    'tw-flex tw-gap-4',
                    textContent.description
                      ? 'tw-mt-6'
                      : 'tw-mt-8 lg:tw-mt-12',
                  )}
                >
                  {primaryButton ? (
                    <ButtonAction
                      href={primaryButton.href}
                      onClick={primaryButton.onClick}
                      label={primaryButton.node}
                      isLoading={primaryButton.isLoading}
                      className={primaryButton.className}
                    />
                  ) : null}
                  {secondaryButton ? (
                    <ButtonAction
                      href={secondaryButton.href}
                      onClick={secondaryButton.onClick}
                      label={secondaryButton.node}
                      color="secondary"
                      isLoading={secondaryButton.isLoading}
                      className={secondaryButton.className}
                    />
                  ) : null}
                  {additionalButton ? (
                    <ButtonAction
                      href={additionalButton.href}
                      onClick={additionalButton.onClick}
                      label={additionalButton.node}
                      color="secondary"
                      isLoading={additionalButton.isLoading}
                      className={additionalButton.className}
                    />
                  ) : null}
                </div>
              </Container>
            </div>
          </BannerImage>
        </div>
      )}
      <BuildNewOrderConfirmationModal
        isOpen={showBuildNewOrderModal}
        onClose={() => setShowBuildNewOrderModal(false)}
        onClear={async () => {
          setShowBuildNewOrderModal(false);
          await handleBuildNewOrder({ clearCart: true });
        }}
        onKeep={async () => {
          setShowBuildNewOrderModal(false);
          await handleBuildNewOrder({ clearCart: false });
        }}
      />
    </>
  );
};

export default IntroBanner;
